export const positionType = {
  LEFT: 'left',
  RIGHT: 'right',
};
